import React, { Component, Fragment } from 'react';
import {
  withStyles,
  Box,
  Typography,
  CircularProgress,
  Button,
  MobileStepper,
  Link,
  Card,
  CardContent,
  CardActions,
  Grid
} from '@material-ui/core';
import { FEED_URLS } from '../../../containers/Dashboard/constants';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { localeMoment as moment } from '../../common/moment';
import PanelTemplate from '../../common/PanelTemplate';
import I18n from '../../../config/locales';
import { get } from '../../../utils/lodash';

const styles = theme => ({
  root: {
    width: '100%'
  },
  title: {
    fontWeight: 'bold',
    fontSize: 18,
    color: '#4D4F5C'
  },
  newsList: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '10px'
  },
  progress: {
    textAlign: 'center'
  },
  nextButton: {
    display: 'flex',
    marginLeft: 'auto'
  },
  button: {
    minWidth: theme.spacing(2),
    maxWidth: theme.spacing(2),
    height: theme.spacing(5),
    boxShadow: '0px 0px 6px #00000029',
    padding: 0
  },
  stepperContent: {
    color: '#43425D',
    fontSize: 15,
    paddingTop: 0,
    marginTop: '0px !important',
    maxHeight: theme.spacing(18.5),
    overflow: 'scroll',
    minWidth: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(17%, 1fr))',
    gridColumnGap: theme.spacing(0.25),
    gridRowGap: theme.spacing(0),
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(auto-fill, minmax(20%, 1fr))'
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(auto-fill, minmax(33%, 1fr))'
    },
    [theme.breakpoints.down('xs')]: {
      minHeight: theme.spacing(30),
      gridTemplateColumns: 'repeat(auto-fill, minmax(100%, 1fr))'
    }
  },
  mobileStepper: {
    backgroundColor: theme.palette.secondary.main,
    color: '#43425D',
    justifyContent: 'center',
    position: 'relative',
    top: theme.spacing(1)
  },
  stepperContentWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  panelHead: {
    background: '#f1f1f1',
    color: theme.palette.primary.mainText,
    minHeight: '40px !important',
    height: '40px',
    cursor: 'unset !important'
  },
  panelDetails: {
    flexDirection: 'column',
    maxHeight: '214px'
  },
  heading: {
    fontWeight: 'bold'
  },
  newsCardContent: {
    padding: '10px !important'
  },
  newsCard: {
    boxShadow: '0px 0px 8px #00000029',
    borderRadius: 0,
    height: '100%'
  },
  newsLink: {
    color: '#2679f6',
    fontSize: theme.spacing(1.7)
  },
  newsTime: {
    fontSize: theme.spacing(1.5)
  },
  stepperItem: {
    padding: '8px !important'
  }
});

export class IndustryNews2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stepperData: [],
      fetchingFeed: false,
      activeStep: 0
    };
  }
  getFeeds() {
    try {
      for (let j = 0; j < FEED_URLS.length; j++) {
        fetch(`https://api.rss2json.com/v1/api.json?rss_url=${FEED_URLS[j]}`)
          .then(response => response.json())
          .then(data => {
            // only process news if data.items is an array
            if (Array.isArray(data.items)) {
              let fData = { fTitle: get(data, 'feed.title', ''), items: [] };
              let newData = [];
              for (let i = 0; i < data.items.length; i++) {
                let item = data.items[i];
                newData.push({ title: item.title, description: item.content, link: item.link, pubDate: item.pubDate });
              }
              fData.items = newData;
              let fArray = this.state.stepperData;
              fArray.push(fData);
              if (this.mounted) {
                this.setState({ stepperData: fArray });
              }
            }
          });
      }
    } catch (error) {}
  }
  componentDidMount() {
    this.mounted = true;
    this.getFeeds();
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  getTime(tString) {
    let m = moment(tString).fromNow();
    return m;
  }

  viewNext(counter) {
    let aStep = this.state.activeStep;
    if (counter > 0) {
      if (aStep < this.state.stepperData.length) {
        this.setState({ activeStep: aStep + 1 });
      }
    } else {
      if (this.state.stepperData.length - 1 > aStep - 1) {
        this.setState({ activeStep: aStep - 1 });
      }
    }
  }

  render() {
    const { classes } = this.props;
    const { stepperData, fetchingFeed, activeStep } = this.state;

    return (
      <PanelTemplate header={I18n.t('dashboard.newsBoard')} boxShadow id="newsBoardBox">
        <div style={{ padding: '10px' }}>
          {fetchingFeed === true ? (
            <Box className={(classes.newsList, classes.progress)}>
              <br />
              <CircularProgress size={15} />
            </Box>
          ) : (
            <Fragment>
              {stepperData.length > 0 ? (
                <Fragment>
                  <Typography variant="caption" className={classes.heading}>
                    {stepperData[activeStep].fTitle}
                  </Typography>
                  <Box className={classes.stepperContentWrapper}>
                    <Grid container spacing={3} className={classes.stepperContent}>
                      {stepperData[activeStep].items.map((c, idx) => {
                        return (
                          <Grid key={`news-link-${idx}`} item className={classes.stepperItem}>
                            <Card className={classes.newsCard}>
                              <CardContent className={classes.newsCardContent}>
                                <Link target="_blank" href={c.link} className={classes.newsLink}>
                                  {c.title}
                                </Link>
                                <span className={classes.newsTime}> - {this.getTime(c.pubDate)}</span>
                              </CardContent>
                            </Card>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Box>
                  <MobileStepper
                    variant="dots"
                    steps={stepperData.length}
                    position="static"
                    className={classes.mobileStepper}
                    activeStep={activeStep}
                    nextButton={
                      <Button
                        size="small"
                        onClick={() => this.viewNext(1)}
                        disabled={activeStep === stepperData.length - 1}
                        id="keyboardArrowRightButtonNewsBoard"
                      >
                        <KeyboardArrowRight color={activeStep === stepperData.length - 1 ? 'disabled' : 'primary'} />
                      </Button>
                    }
                    backButton={
                      <Button
                        size="small"
                        onClick={() => this.viewNext(-1)}
                        disabled={activeStep === 0}
                        id="keyboardArrowLeftButtonNewsBoard"
                      >
                        <KeyboardArrowLeft color={activeStep === 0 ? 'disabled' : 'primary'} />
                      </Button>
                    }
                  />
                </Fragment>
              ) : (
                <Typography variant="caption">{`** ${I18n.t('dashboard.noContentAvailable')} **`}</Typography>
              )}
            </Fragment>
          )}
        </div>
      </PanelTemplate>
    );
  }
}

export default withStyles(styles)(IndustryNews2);
